import { Typography, styled } from '@mui/material';
import { useEffect, useState } from 'react';
import LabLoader from './LabLoader';
import { useTranslation } from 'react-i18next';

const LabLoaderContainer = styled('div')({
  position: 'absolute',
  background: '#eee',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'none',
  alignItems: 'center',
  zIndex: 40,
  justifyContent: 'center',
  flexDirection: 'column',
  opacity: 0,
  pointerEvents: 'none',
  transition: 'opacity 360ms ease',

  '&.active': {
    display: 'flex',
  },

  '&.visible': {
    opacity: 1,
    pointerEvents: 'auto',
  },
  
  '&.overlayed': {
    opacity: 0.8,
    pointerEvents: 'auto',
  }
})

interface Props {
  hide?: boolean
  overlay?: boolean
}

export default function FullPageLabLoader(props: Props) {
  const [t] = useTranslation('design-lab');

  const [opened, setOpened] = useState(!props.hide);
  const [visible, setVisible] = useState(!props.hide);

  useEffect(() => {
    if (props.hide) {
      setVisible(false);

      const timeout = setTimeout(() => {
        setOpened(false);
      }, 360);

      return () => clearTimeout(timeout);
    }

    setOpened(true);

    if (typeof window === 'undefined') {
      setVisible(true);
      return undefined;
    }

    const frame = window.requestAnimationFrame(() => {
      setVisible(true);
    });

    return () => window.cancelAnimationFrame(frame);
  }, [props.hide])

  return <LabLoaderContainer className={(opened ? 'active' : '') + (visible ? (props.overlay ? ' overlayed' : ' visible') : '')}>
    <Typography
      variant="h2"
      style={{
        marginBottom: '20px',
      }}
    >{t('Loading')}</Typography>
    <LabLoader />
  </LabLoaderContainer>
}
